import GeneralHelper from "../../../common/helpers/GeneralHelper";
import CustomerService from "../../../common/services/customer/CustomerService";
import axios from "../../../common/utils/axios";

export default {
    actions: {
        sendMessage: (context, message) => {
            var customerService = new CustomerService()
            var result = customerService.contactUs(message, { message: { success: GeneralHelper.buildMessage(4, "Thank you for contacting us") } })
            return result
        },
    },
};